module.exports = __webpack_public_path__ + "img/project_21.84cedc9c.jpg";